import {SynapiImage} from "./SynapiImage";
import {SynapiContacts} from "./SynapiContacts";
import {SynapiHebergementMeuble} from "./SynapiHebergementMeuble";
import {SynapiCriteriaTreeItem} from "./SynapiCriteriaTreeItem";
import {SynapiAdressePrincipale} from "./SynapiAdressePrincipale";
import {SynapiTaxonomy} from "./SynapiTaxonomy";
import {SynapiLocalisation} from "./SynapiLocalisation";
import {SynapiItemTypes} from "./enums/SynapiItemTypes";


export class SynapiItem {
    Description: string;
    Name: string;
    DescriptifsThematiques: any;
    Images: SynapiImage[];
    Tarifs: string;
    LastModified: string;
    TypeFiche : SynapiItemTypes;
    AdresseGestion: any;
    Contacts: SynapiContacts;
    Reservation: SynapiContacts;
    FichesLiees: SynapiItem[];
    Aspects: SynapiItem[];
    Treck: any;
    HebergementMeuble: SynapiHebergementMeuble;
    CriteriaTrees: SynapiCriteriaTreeItem[];
    FlatCriterias: SynapiCriteriaTreeItem[];
    Slug: string;
    ShortDesc: string;
    ImageUrl: string;
    AdressePrincipale: SynapiAdressePrincipale;
    Ouverture: string;
    Categorie: SynapiCriteriaTreeItem;
    CategorieDetaillee: SynapiCriteriaTreeItem;
    Categories: SynapiCriteriaTreeItem[];
    Equipements: SynapiCriteriaTreeItem[];
    Services: SynapiCriteriaTreeItem[];
    Activites: SynapiCriteriaTreeItem[];
    Source : {
      OwnerName: string;
      LastModified: string;
      Created: string;
      OwnerContacts: string[];
    }
    TourismeAffaire: {
      NbSalles : number,
      CapaciteMax : number,
      Usages: SynapiCriteriaTreeItem[];
      Equipements: SynapiCriteriaTreeItem[];
      Hebergements: SynapiCriteriaTreeItem[];
      Restauration: SynapiCriteriaTreeItem[];
      SallesReunion: {
        Name: string,
        CapaciteMax : number,
        Superficie : number,
        Dispositions : {
          Capacite: number,
          id: string,
          name:string
        },
      }[];
    };
    LargeOuverturePeriode : {
      Start: string,
      End: string
    };
    NextOuverturePeriode : {
      Start: string,
      End: string
    };
    Classements: SynapiTaxonomy[];
    Capacites : {
      NumAgrement: string,
      Surface: number,
      Capacite: number,
      NbChambres: number,
      NbChambresClassees: number,
      NbEmplacementsClasses: number,
      NbEmplacements: number,
      NbHebergements: number,
      CapaciteGlobale: number,
    }
    Labels: any[];
    Id: number;
    ExternalId: string;
    Title: string;
    Localisation: SynapiLocalisation;
    Tri: string;
}















